import React, { useState, useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import { selectIncidents } from 'store/selectors';
import { createIncident, fetchIncidents } from 'store/entities/incidents/incidentsThunk';
import {
  updatePage,
  updateIncident,
  resetIncidents,
} from 'store/entities/incidents/incidentsSlice';
import { IncidentsManageProps } from './IncidentsManage.props';
import IncidentsManageView from './IncidentsManage.view';
import useIncidentForm from './hooks/useIncidentForm';
import { SubmitHandler, useForm } from 'react-hook-form';
import { QueryState } from 'common/enums';
import { IIncident } from 'interfaces/incident.interface';
import { ApiIncidentManageFilters } from '../../../services/incidentsEndPoints';
import { DashboardMainProps } from '../DashboardMain/DashboardMain.props';

const IncidentsManage: React.FC<DashboardMainProps> = (props) => {
  const dispatch = useAppDispatch();
  const { pageLimit, state, incidents, page, pageTotal } = useAppSelector(selectIncidents);
  const incidentsList = incidents || [];
  const form = useIncidentForm();
  const loading = state === QueryState.AWAIT;
  const [addIncidentModal, setAddIncidentModal] = useState<boolean>(false);
  const [editIncidentModal, setEditIncidentModal] = useState<boolean>(false);
  const handleManageIncidentModal = props.handleManageIncidentModal;

  useEffect(() => {
    dispatch(resetIncidents());
  }, []);

  const onCreateIncident: SubmitHandler<IIncident> = async (data) => {
    // console.log('data', data);
    await dispatch(createIncident(data));
    const filters: ApiIncidentManageFilters = {
      keyword: '',
      limit: pageLimit,
      offset: 1,
    };
    dispatch(fetchIncidents(filters));
    form.reset();
    setAddIncidentModal(false);
  };

  const handleAddModal = (show: boolean) => {
    setAddIncidentModal(show);
    form.reset();
  };

  const handleEditModal = (show: boolean) => {
    //console.log('show', show);
    setEditIncidentModal(show);
  };

  const onNavigate = async (id: string) => {
    const incidentInfo = incidentsList.find((incident) => incident.id === id);
    if (incidentInfo) {
      await dispatch(updateIncident(incidentInfo));
      setEditIncidentModal(true);
    }
  };

  const handlePageChange = (num: number) => {
    if (num !== page) {
      dispatch(updatePage({ PageNum: num }));
    }
  };

  const combinedProps: IncidentsManageProps = {
    form,
    incidentsList,
    loading,
    addIncidentModal,
    editIncidentModal,
    page,
    pageTotal,
    handleAddModal,
    handleEditModal,
    onCreateIncident,
    onNavigate,
    handlePageChange,
    handleManageIncidentModal
  };
  return <IncidentsManageView {...combinedProps} />;
};

export default IncidentsManage;
